
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testimonals",
      function () {
        return require("private-next-pages/testimonals/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testimonals"])
      });
    }
  